namespace $.$$ {

	$mol_style_define( $.$hyoo_intern_resume_card, {

		Resume_form: {
			flex: {
				grow: 1,
			},
		},

		Job_form: {
			background: {
				color: $mol_theme.card,
			},
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
			},
			margin: {
				bottom: $mol_gap.block,
			},
			border: {
				radius: $mol_gap.round,
			},
		},
		Jobs_field: {
			Label: {
				alignItems: 'center',
			},
		},
		Skills_field: {
			Label: {
				alignItems: 'center',
			},
		},

		Institution_form: {
			background: {
				color: $mol_theme.card,
			},
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
			},
			margin: {
				bottom: $mol_gap.block,
			},
			border: {
				radius: $mol_gap.round,
			},
		},
		Institutions_field: {
			Label: {
				alignItems: 'center',
			},
		},

		Accept: {
			padding: $mol_gap.block,
		},

	} )

}
